import React, { ReactElement } from 'react';
import styled from '@emotion/styled';

import { getBorders } from '../../style';

const List = styled('ul')({
  margin: '0',
  padding: '0',
  listStyle: 'none',
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ListItem = styled('li')(() => ({
  margin: '0',
  padding: '0',
  textAlign: 'center',

  borderBottom: getBorders().DASHED,
  ':last-child': {
    borderBottomWidth: '0',
  },
}));

const MenuList = (props: any): ReactElement => {
  const { customStyle } = props;

  if (customStyle) {
    return <List style={customStyle}>{props.children}</List>;
  }

  // Default style
  return <List>{props.children}</List>;
};

const MenuListItem = (props: any): ReactElement => {
  const { customStyle } = props;

  if (customStyle) {
    return <ListItem style={customStyle}>{props.children}</ListItem>;
  }

  return <ListItem>{props.children}</ListItem>;
};

export { MenuList, MenuListItem };
